export const vocabProgressLevels = {
  COMPLETE: 3,
  FORGOTTEN: 2,
  STRUGGLING: 1,
};
